import { combineReducers } from 'redux';
import { createReducer } from 'typesafe-actions';
import { normalizeBankTransactionListResponse } from 'lib/normalization';
import {
  clearBankTransactionMapStatus,
  setTransactionMappingStatus,
  setTransactionNoteStatus,
} from 'lib/transactions';
import { NoteAction } from 'store/notes';
import { BankTransactionHandleAction, TransactionHandleAction } from 'store/transactions';
import { BankTransaction } from 'types/dto';
import { SortDirection } from 'types/sort';
import { RequestStatus } from 'types/transport';
import { BankTransactionAction } from './actions';

const entitiesReducer = createReducer<Record<string, BankTransaction>>({})
  .handleType(BankTransactionAction.Clear, () => ({}))
  .handleType(BankTransactionAction.ListResponse, (state, action) => {
    const [entities] = normalizeBankTransactionListResponse(action.payload);
    return entities;
  })
  .handleType(BankTransactionHandleAction.ArchiveResult, (state, action) => {
    const { bankTransactions = [], transactionId } = action.payload;
    return setTransactionMappingStatus(state, bankTransactions, transactionId, 'IGNORED');
  })
  .handleType(BankTransactionHandleAction.RestoreResponse, (state, action) =>
    clearBankTransactionMapStatus(state, action.payload),
  )
  .handleType(NoteAction.Response, (state, action) => {
    const { transactionId } = action.payload;
    return setTransactionNoteStatus(state, [transactionId], true);
  })
  .handleType(TransactionHandleAction.UnmatchResponse, (state, action) =>
    clearBankTransactionMapStatus(state, action.payload),
  )
  .handleType(TransactionHandleAction.MatchResult, (state, action) => {
    const { bankTransactions = [], transactionId } = action.payload;
    return setTransactionMappingStatus(state, bankTransactions, transactionId, 'MATCHED');
  })
  .handleType(TransactionHandleAction.AutoMatchResult, (state, action) => {
    const { bankTransactions = [], transactionMappingId } = action.payload;
    return setTransactionMappingStatus(state, bankTransactions, transactionMappingId, 'MATCHED');
  });

const idsReducer = createReducer<Array<string>>([])
  .handleType(BankTransactionAction.Clear, () => [])
  .handleType(BankTransactionAction.ListResponse, (state, action) => {
    const [, ids] = normalizeBankTransactionListResponse(action.payload);
    return ids;
  });

const queryReducer = createReducer<string>('')
  .handleType(BankTransactionAction.Clear, () => '')
  .handleType(BankTransactionAction.Query, (state, action) => action.payload);

const selectedReducer = createReducer<Array<string>>([])
  .handleType(BankTransactionAction.Clear, () => [])
  .handleType(BankTransactionAction.Select, (state, action) => action.payload);

const sortDirReducer = createReducer<Nullable<SortDirection>>(null).handleType(
  BankTransactionAction.Sort,
  (state, action) => action.payload.direction ?? null,
);

const sortKeyReducer = createReducer<Nullable<string>>(null).handleType(
  BankTransactionAction.Sort,
  (state, action) => action.payload.key ?? null,
);

const statusReducer = createReducer<RequestStatus>(RequestStatus.None)
  .handleType(BankTransactionAction.Clear, () => RequestStatus.None)
  .handleType(BankTransactionAction.Error, () => RequestStatus.Error)
  .handleType(BankTransactionAction.ListRequest, () => RequestStatus.Reading)
  .handleType(BankTransactionAction.ListResponse, () => RequestStatus.Success);

export default combineReducers({
  entities: entitiesReducer,
  ids: idsReducer,
  query: queryReducer,
  selected: selectedReducer,
  sortDir: sortDirReducer,
  sortKey: sortKeyReducer,
  status: statusReducer,
});
